<template>
  <div class="app_container">
    <search ref="searchComp" class="search-wrapper" @search="onSearch" />

    <div class="table-column-check-list">
      <butn style="height: 28px" btntype="primary" title="导出" @click="onExport" v-permission="'train:exportXls'"
        :disabled="list.length <= 0"></butn>
      <butn style="height: 28px; margin-left: 10px;" btntype="primary" title="导出结果" @click="onExportResult"></butn>
      <butn style="height: 28px" btntype="primary" title="添加选调学员" @click="showModal" v-permission="'train:save'"
        :disabled="!superiorTrainEnable"></butn>

      <span class="tip_msg">（数据更新至昨日23:59）</span>
    </div>
    <el-table ref="pageListTable" header-row-class-name="RCTableHeader" cell-class-name="RCTableCell" :data="list"
      stripe :row-style="{ color: '#51627D', fontWeight: 400 }" :header-cell-style="{
        background: '#DCE7FA',
        color: '#343C4A',
        fontWeight: 500,
      }" @sort-change="sortChange" @selection-change="selectChange">
      <el-table-column type="selection" width="40"> </el-table-column>
      
      <!-- 遍历 tableColumn 中 userName 列 -->
      <el-table-column 
        prop="userName"
        label="姓名"
        class-name="train-list-column"
        minWidth="120"
        showOverflowTooltip
      >
        <template slot-scope="scope">
          <span class="base-hover-char" @click="toStudyInfo(scope.row)">{{ scope.row.userName }}</span>
        </template>
      </el-table-column>
      
      <!-- 遍历 tableColumn 中 userBirthday 列 -->
      <el-table-column 
        prop="userBirthday"
        label="出生年月"
        class-name="train-list-column"
        minWidth="100"
        sortable="custom"
      />
      
      <!-- 遍历 tableColumn 中 deptName 列 -->
      <el-table-column 
        prop="deptName"
        label="工作单位"
        class-name="train-list-column"
        minWidth="180"
        showOverflowTooltip
      />
      
      <!-- 遍历 tableColumn 中 unitPosition 列 -->
      <el-table-column 
        prop="unitPosition"
        label="现任单位及职务"
        class-name="train-list-column"
        minWidth="180"
        showOverflowTooltip
      />
      
      <!-- 独立出来的 totalDaysStr 列，位于现任单位及职务和培训码之间 -->
      <el-table-column 
        prop="totalDays"
        :label="totalDaysLabel"
        class-name="train-list-column"
        minWidth="142"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span>{{ formatTotalDays(scope.row.totalDaysStr) }}</span>
           <!-- <span>{{ scope.row.totalDays }}</span>  -->
        </template>
      </el-table-column>
      
      <!-- 遍历 tableColumn 中 trainCode 列 -->
      <el-table-column 
        prop="trainCode"
        label="培训码"
        class-name="train-list-column"
        minWidth="70"
        showOverflowTooltip
      >
        <template slot="header">
          <div class="final-code-head">
            <div>培训码</div>
            <i class="el-icon-info icon-info" @click="showExamRuleInfo"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <span :class="getClass(scope.row.trainCode, scope.row)">{{
            scope.row.trainCode == 1
              ? "绿码"
              : scope.row.trainCode == 2
                ? "黄码"
                : scope.row.trainCode == 3
                  ? "红码"
                  : "不考核"
          }}</span>
        </template>
      </el-table-column>
      
      <!-- 遍历 tableColumn 中 totalLength 列 -->
      <el-table-column 
        prop="totalLength"
        label="近五年集中培训学时数"
        class-name="train-list-column"
        minWidth="150"
        sortable="custom"
      />
      
      <el-table-column key="train-do" class-name="train-list-column" width="60" label="操作">
        <template slot-scope="scope">
          <div class="deal-group">
            <el-tooltip content="查看培训详情" placement="top" v-permission="'trainDetail:page'">
              <i class="iconfont icchakanpeixunxiangqing_sel iconfont-adapt" @click="toTrainDia(scope.row)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="sizeChange" @current-change="pageChange" :current-page="currentPage"
      :page-size="size" :page-sizes="[10, 50, 100, 500, 1000]" layout="total, sizes, prev, pager, next, jumper"
      :total="total" background />
    <AddTrainModal v-if="showTrainModal.flag" :selectUsers="checkArray" :showTrainModal="showTrainModal"
      @closeTrainModal="closeTrainModal" />
    <TrainDia v-if="showTrainDia.show" :trainDiaInfo="showTrainDia" @close="closeTrainDia" />
    <RuleInfo ref="ruleInfoRef" />
    <ExportConfirmModal 
      :visible="showExportModal" 
      @close="showExportModal = false" 
      @confirm="handleExportConfirm" 
    />
    <ExportStatusModal 
      :visible="showExportStatusModal" 
      @close="handleExportStatusClose" 
    />
    <ExportResultModal 
      :visible="showExportResultModal" 
      :export-data="exportResultData"
      @close="showExportResultModal = false" 
    />
  </div>
</template>

<script>
import Search from "./search";
import butn from "@/components/button/index";
import { getTrainList, exportTrainList, getStudentTrainExport } from "@/api/train";
import { getItem, removeItem } from "../../utils/storage";
import AddTrainModal from "./addTrainUsersModal.vue";
import TrainDia from "./trainDia/index.vue";
import "@/components/list/table.css";
import RuleInfo from "@/pages/trainCodeRule/ruleInfo.vue";
import ExportConfirmModal from './trainExport/exportConfirmModal.vue'
import ExportStatusModal from './trainExport/exportStatusModal.vue'
import ExportResultModal from './trainExport/exportResultModal.vue'
import { BaseConfirm } from "@/components/Confirm";

export default {
  name: "train",
  components: {
    Search,
    butn,
    AddTrainModal,
    TrainDia,
    RuleInfo,
    ExportConfirmModal,
    ExportStatusModal,
    ExportResultModal,
  },
  data() {
    return {
      exportDetail: false,
      showExportModal: false,
      showExportStatusModal: false,
      showExportResultModal: false,
      exportResultData: null,
      list: [],
      dataname: {},
      currentPage: 1,
      size: 10,
      total: 0,
      tableColumn: [
      ],
      tableInfoParams: [
        {
          prop: "userSexName",
          label: "性别：",
        },
        {
          prop: "userMobile",
          label: "手机号码：",
        },
        {
          prop: "positionTagName",
          label: "职务层次：",
        },
        {
          prop: "positionLevelName",
          label: "职级：",
        },
        {
          prop: "leaderTypeName",
          label: "管理主体：",
        },
        {
          prop: "partyLeader",
          label: "党委一把手：",
        },
        {
          prop: "governmentLeader",
          label: "政府一把手：",
        },
        {
          prop: "userPoliticsName",
          label: "政治面貌：",
        },
      ],
      sort: {
        totalDaysSort: "",
        userNameSort: "",
        userBirthdaySort: "",
        currentPositionTimeSort: "",
        currentPositionLevelTimeSort: "",
        totalLengthSort: "",
      },
      checkArray: [],
      showTrainModal: {
        flag: false,
      },
      showTrainDia: {
        show: false,
      },
    };
  },
  created() {
    // this.getTrainList()
  },

  activated() {
    if (getItem(this.REFRESH_FLAG)) {
      this.onSearch(this.dataname);
      removeItem(this.REFRESH_FLAG);
    }
  },
  computed: {
    superiorTrainEnable() {
      return this.checkArray.length > 0;
    },
    totalDaysLabel() {
      if (this.dataname.trainStartTime && this.dataname.trainEndTime) {
        const startDate = this.dataname.trainStartTime.replace(/-/g, '.');
        const endDate = this.dataname.trainEndTime.replace(/-/g, '.');
        return `${startDate}至${endDate}\n合计培训天数/学时数`;
      }
      return '合计培训天数/学时数';
    }
  },
  methods: {
    async onExport() {
      this.showExportModal = true;
      // const flag = await BaseConfirm("确定导出当前搜索结果所有数据吗？");
      // if (!flag) return;
      // this.exportTrainList_Old();

    },

    // 改回旧导出
    exportTrainList_Old() {
      const params = {
        ...this.dataname,
      };
      exportTrainList(params)
        .then((response) => {
          let data = response.data;
          let fileReader = new FileReader();
          let _this = this;
          fileReader.onload = function () {
            try {
              let jsonData = JSON.parse(this.result);
              if (jsonData.code) {
                _this.$message({
                  message: jsonData.msg,
                  type: "error",
                });
              }
            } catch (e) {
              let blob = new Blob([response.data], {
                type: "application/vnd.ms-excel",
              }); //创建一个blob对象
              const uA = window.navigator.userAgent;
              const isIE =
                /msie\s|trident\/|edge\//i.test(uA) &&
                !!(
                  "uniqueID" in document ||
                  "documentMode" in document ||
                  "ActiveXObject" in window ||
                  "MSInputMethodContext" in window
                );
              let a = document.createElement("a"); //创建一个<a></a>标签
              let href = window.URL.createObjectURL(blob); // response is a blob
              a.href = href;
              let title = decodeURI(escape(response.headers.downloadname)); //文件名称
              a.download = title;
              a.style.display = "none";
              document.body.appendChild(a);
              if (isIE) {
                // 兼容IE11无法触发下载的问题
                navigator.msSaveBlob(blob, title);
              } else {
                a.click();
              }
              document.body.removeChild(a); // 下载完成移除元素
              // window.URL.revokeObjectURL(href); // 释放url
            }
          };
          fileReader.readAsText(data);
        })
        .catch((_) => console.log(_));
    },
    onExportResult() {
      getStudentTrainExport().then(response => {
        if (response && response.code === 0) {
          // 保存返回的数据
          this.exportResultData = response.data || null;
          // 显示导出结果模态框
          this.showExportResultModal = true;
        } else {
          this.$message.error(response.msg || '获取导出结果失败');
        }
      }).catch(error => {
        this.$message.error('获取导出结果失败，请稍后重试');
      });
    },
    handleExportConfirm(exportType) {
      this.showExportModal = false;
      this.exportDetail = exportType === 1;
      this.exportTrainList();
    },
    handleExportStatusClose() {
      this.showExportStatusModal = false;
    },
    // 搜索
    onSearch(params) {
      this.dataname = {
        ...params,
      };
      this.getTrainList();
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    sizeChange(size) {
      this.size = size;
      this.getTrainList();
    },

    pageChange(page) {
      this.currentPage = page;
      this.getTrainList();
    },
    sortChange({ prop, order }) {
      const sortMap = {
        ascending: 1,
        descending: 0,
      };
      const key = `${prop}Sort`;
      Object.keys(this.sort).forEach((item) => {
        this.sort[item] = key === item ? sortMap[order] : "";
      });
      this.currentPage = 1;
      this.getTrainList();
    },
    // 添加选调人员
    showModal() {
      this.showTrainModal = { flag: true };
    },
    closeTrainModal() {
      this.showTrainModal = { flag: false };
    },
    // 排序相关
    isZero(val) {
      return String(val) === "0";
    },
    isTrue(val) {
      return !!val || this.isZero(val);
    },
    // 接口请求
    getTrainList() {
      if (!this.dataname.deptLevelCodes || this.dataname.deptLevelCodes.length === 0) {
        this.$message.warning('请先选择培训选调部门')
        return;
      }
      const sort = {};
      Object.keys(this.sort)
        .filter((item) => this.isTrue(this.sort[item]))
        .map((item) => {
          sort[item] = this.sort[item];
        }) || {};
      const params = {
        ...this.dataname,
        ...sort,
        page: this.currentPage || 1,
        limit: this.size || 10,
      };
      getTrainList(params)
        .then((res) => {
          if (!res || res.code != 0) return;
          this.list = res.data.records;
          this.total = (res && res.data && res.data.total) || 0;
          this.size = (res && res.data && res.data.size) || 0;
          this.currentPage = (res && res.data && res.data.current) || 1;
        })
        .catch((_) => console.log(_));
    },
    // 导出
    exportTrainList() {
      this.showExportStatusModal = true;
      const params = {
        ...this.dataname,
        exportType: this.exportDetail ? 1 : 2
      };
      
      exportTrainList(params)
        .then((response) => {
          if (response && response.status === 200) {     
          } else {
            this.$message({
              message: response.msg || "导出失败",
              type: "error",
            });
            this.showExportStatusModal = false;
          }
        })
        .catch((error) => {
          this.$message({
            message: "导出失败，请稍后重试",
            type: "error",
          });
          this.showExportStatusModal = false;
        });
    },
    getSortKeys() {
      return this.tableColumn
        .filter((item) => !!item.sortable)
        .map((item) => item.prop);
    },
    getClass(val, item) {
      switch (val) {
        case 1:
          return "greenText";
        case 2:
          return "yellowText";
        case 3:
          return "redText";
        default:
          return "";
      }
    },
    toTrainDia(item) {
      const filters = {
        ...this.dataname,
        participatedUserId: item.userId,
      };      
      this.showTrainDia = {
        show: true,
        userInfo: item,
        filters,
      };
    },
    closeTrainDia() {
      this.showTrainDia = { show: false };
    },
    showExamRuleInfo() {
      this.$refs.ruleInfoRef.show();
    },
    toStudyInfo(item) {
      this.$store.commit("app/setNowStudent", {
        uuid: item.userId,
        userName: item.userName,
        userMobile: item.userMobile,
        unitPosition: item.unitPosition
      });
      this.$router.push({
        path: "/user/studyInfo",
        query: {
          uuid: item.userId
        }
      });
    },
    //培训天数/时长前者保留2位小数，后者取整
    formatTotalDays(totalDaysStr) {
      if (!totalDaysStr) return '';
      
      const parts = totalDaysStr.split('/');
      if (parts.length !== 2) return totalDaysStr;
      
      const days = this.formatNumber(parts[0]);
      const hours = this.formatNumber(parts[1]);
      
      if (isNaN(days) || isNaN(hours)) return totalDaysStr;
      
      return `${days} / ${hours}`;
    },

     formatNumber(value) {
        const num = parseFloat(value);
        if (Number.isInteger(num)) {
          return parseInt(num);
        } else {
          // 转为字符串后去除末尾的0
          return parseFloat(num.toFixed(3));
        }
      }

  },
};
</script>

<style lang="scss" scoped>

/deep/.el-table .cell {
  white-space: pre-wrap;
}

/deep/.el-table__expanded-cell {
  background: #f8f8f8;
}

/deep/.el-table__expanded-cell[class*="cell"] {
  padding: 20px 30px;
}

/deep/ .el-pagination .el-select .el-input {
  width: 100px !important;
}

.pagination {
  margin-top: 10px;
}

.m-l-14 {
  margin-left: 14px;
}

.tip_msg {
  float: right;
  font-size: 1rem;
  color: #909399;
  text-align: center;
  line-height: 30px;
}

.table-column-check-list {
  margin-bottom: 10px;

  /deep/ .el-checkbox-group {
    display: inline;
    margin-left: 20px;

    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 10px;
    }
  }
}
.final-code-head {
  width: 100%;
  display: flex;
  align-items: center;
  
  .icon-info {
    font-size: 18px;
    margin-left: 4px;
    margin-right: 0 !important;
  }
}

// 或者更具体地针对表头单元格
/deep/ .RCTableHeader th {
  // line-height: 80px;
}
</style>
